import { render, staticRenderFns } from "./PolicyFormAdditional.vue?vue&type=template&id=6bfd6a26&scoped=true&"
import script from "./PolicyFormAdditional.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormAdditional.vue?vue&type=style&index=0&id=6bfd6a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd6a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
